import {
  Directive,
  HostBinding,
  HostListener,
} from '@angular/core';

import { SipPhoneCallService } from './sip-phone-call.service';

@Directive({
	selector: 'a[appSipPhoneCall]',
	standalone: false,
})
export class SipPhoneCallDirective {

	@HostBinding('href')
	public href: string = this.sipPhoneCallService.href;

	constructor(
		private sipPhoneCallService: SipPhoneCallService,
	) { }


	@HostListener('click', ['$event'])
	public callViaSip(event: Event): void {
		event.preventDefault();
		this.sipPhoneCallService.startCall();
	}

}
